export const spinnerNames = {
  1: 'ring',
  2: 'dual',
  3: 'dots',
  4: 'pulse',
  5: 'bars',
  6: 'grid',
  7: 'double-ring',
  8: 'circle-dots',
  9: 'flip',
  10: 'gooey',
  11: 'corner',
  12: 'ripple',
  13: 'pendulum',
  14: 'snake',
  15: 'bounce-dots',
  16: 'spiral',
  17: 'clock',
  18: 'gradient',
  19: 'zigzag',
  20: 'orbit',
  21: 'square-spin',
  22: 'slice',
  23: 'ping',
  24: 'infinity',
  25: 'windmill',
  26: 'hexagon',
  27: 'triangle-spin',
  28: 'diamond',
  29: 'star',
  30: 'gear',
  31: 'dots-wave',
  32: 'worm',
  33: 'squares-rotate',
  34: 'helix',
  35: 'circles-merge',
  36: 'atom',
  37: 'roller',
  38: 'cascade',
  39: 'blockchain',
  40: 'heartbeat',
  41: 'flower',
  42: 'radar',
  43: 'wave-circle',
  44: 'pacman',
  45: 'hourglass',
  46: 'cube-fold',
  47: 'dashed-ring',
  48: 'newton-cradle',
  49: 'metronome',
  50: 'spinner-box'
};
